import React, { Component } from 'react'
import { Button, Checkbox, Dropdown, Input, Menu, Select, Table } from 'antd'
import { Redirect } from 'react-router-dom'
import _ from 'lodash'

import DocumentListModal from '../DocumentListModal/DocumentListModal'
import './DocumentList.scss'

const { Search } = Input
const { Option } = Select
const CheckboxGroup = Checkbox.Group
const checkboxList = ['Quotation', 'Sub-quotation', 'Notice', 'Variation Order', 'Working Progress']

export default class DocumentList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showDocumentListModal: false,
            selectedDocumentType: '',
            documentList: [],
            redirectTo: ''
        }

        this.getExpandedTable = this.getExpandedTable.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    }

    getExpandedTable(parentData) {
        const { onDocumentChange, childColumns, selectedDocumentIdx, selectedDocumentProjectId, disabled } = this.props
        const createNewDropdown = (
            <Dropdown overlay={this.renderSpecificMenu(parentData)} trigger={['click']}>
                <Button type="primary">Create New</Button>
            </Dropdown>
        )

        return (
            <Table
                className="expanded-table"
                rowKey={'_id'}
                columns={childColumns}
                dataSource={parentData.documents}
                pagination={false}
                onRowClick={onDocumentChange}
                rowClassName={(record, index) => (index === selectedDocumentIdx) && (selectedDocumentProjectId === record.project_id) ? 'selected' : ''}
                footer={() => disabled ? '' : createNewDropdown}
            />
        )
    }

    handleCheckboxChange(checkedList) {
        this.setState({ checkedList })
    }

    handleCreateNewMenuSelect(item) {
        const { onCreateNewProject, originalDataset } = this.props
        let documentList = originalDataset

        if (item.key !== 'project') {
            switch (item.key) {
                case 'notice':
                    documentList = _.filter(originalDataset, (project, projectIdx) => {
                        if (!_.some(project.documents, { type: 'variation-order', sent: true }))
                            return project
                    })
                    break
                default:
            }

            this.setState({ selectedDocumentType: item.key, documentList })
            this.openDocumentListModal()
        } else {
            onCreateNewProject()
            this.setState({ redirectTo: '/workdesk/project/new' })
        }
    }

    handleSpecificCreateNewMenuSelect(project, item) {
        const { _id: projectId } = project
        this.setState({ redirectTo: `/workdesk/project/${projectId}/document/new?type=${item.key}` })
    }

    openDocumentListModal() {
        this.setState({ showDocumentListModal: true })
    }

    closeDocumentListModal() {
        this.setState({ showDocumentListModal: false })
    }

    componentDidUpdate(prevProps, prevState) {
        const { originalDataset } = this.props
        if (!_.isEqual(prevProps.originalDataset, originalDataset))
            this.setState({ documentList: originalDataset })
    }

    renderSpecificMenu(project) {
        const { status: projectStatus } = project

        return (
            <Menu onClick={this.handleSpecificCreateNewMenuSelect.bind(this, project)}>
                <Menu.Item key="budget-estimation" disabled={projectStatus !== 'proposed'}>
                    Budget Estimation
                </Menu.Item>
                <Menu.Item key="quotation" disabled={projectStatus !== 'proposed'}>
                    Quotation
                </Menu.Item>
                <Menu.Item key="sub-quotation" disabled={projectStatus !== 'active'}>
                    Sub-quotation
                </Menu.Item>
                <Menu.Item key="notice" disabled={projectStatus !== 'active'}>
                    Notice
                </Menu.Item>
             </Menu>
        )
    }

    renderMenu() {
        const { projectStatus } = this.props

        return (
            <Menu onClick={this.handleCreateNewMenuSelect.bind(this)}>
                <Menu.Item key="project">
                    Project
                </Menu.Item>
                <Menu.Item key="budget-estimation" disabled={projectStatus !== 'proposed'}>
                    Budget Estimation
                </Menu.Item>
                <Menu.Item key="quotation" disabled={projectStatus !== 'proposed'}>
                    Quotation
                </Menu.Item>
                <Menu.Item key="sub-quotation" disabled={projectStatus !== 'active'}>
                    Sub-quotation
                </Menu.Item>
                <Menu.Item key="notice" disabled={projectStatus !== 'active'}>
                    Notice
                </Menu.Item>
             </Menu>
        )
    }

    render() {
        const { beforeCreateNewProject, onProjectChange, onFilterChange, onDocTypeFilterChange, onSearchBarInputChange, checkedDocType, parentColumns, dataset, filter, searchBarInput, locationList, estateList, selectedProjectIdx, modalBtnText, modalRedirect } = this.props
        const { showDocumentListModal, selectedDocumentType, documentList, redirectTo } = this.state
        const { category, type, size, siteLocation, estateName } = filter

        if (redirectTo !== '')
            return <Redirect to={redirectTo}/>
        else
            return (
                <div className="DocumentList">
                    <div className="document-type-selector">
                        <CheckboxGroup 
                            className="document-type-checkbox-gp" 
                            options={checkboxList}
                            value={checkedDocType}
                            onChange={onDocTypeFilterChange.bind(this)}
                        />
                        <Dropdown overlay={this.renderMenu()} trigger={['click']}>
                            <Button type="primary">Create New</Button>
                        </Dropdown>
                    </div>
                    <div className="main-body">
                        <div className="filter">
                            <Select 
                                placeholder="Category" 
                                dropdownMatchSelectWidth={false} 
                                value={category}
                                onChange={onFilterChange.bind(this, 'category')}
                                allowClear
                            >
                                <Option value="RE">RE</Option>
                                <Option value="OF">OF</Option>
                                <Option value="MI">MI</Option>
                            </Select>
                            <Select 
                                placeholder="Type" 
                                dropdownMatchSelectWidth={false} 
                                value={type}
                                onChange={onFilterChange.bind(this, 'type')}
                                allowClear
                            >
                                <Option value="Apartment">Apartment</Option>
                                <Option value="House">House</Option>
                                <Option value="Subdivided Flat">Subdivided Flat</Option>
                                <Option value="Shop">Shop</Option>
                                <Option value="NGO">NGO</Option>
                                <Option value="Restaurant">Restaurant</Option>
                                <Option value="Elderly House">Elderly House</Option>
                                <Option value="School">School</Option>
                                <Option value="Office">Office</Option>
                            </Select>
                            <Select 
                                placeholder="Size" 
                                dropdownMatchSelectWidth={false} 
                                value={size}
                                onChange={onFilterChange.bind(this, 'size')}
                                allowClear
                            >
                                <Option value="<= 300">&lt;= 300</Option>
                                <Option value="301 - 500">301 - 500</Option>
                                <Option value="501 - 800">501 - 800</Option>
                                <Option value="> 800">&gt; 800</Option>
                            </Select>
                            <Select 
                                placeholder="Location" 
                                dropdownMatchSelectWidth={false} 
                                value={siteLocation}
                                onChange={onFilterChange.bind(this, 'siteLocation')}
                                allowClear
                            >
                                {
                                    _.map(locationList, (location, i) => (
                                        <Option key={location} value={location}>{location}</Option>
                                    ))
                                }
                            </Select>
                            <Select 
                                placeholder="Estate" 
                                dropdownMatchSelectWidth={false} 
                                value={estateName}
                                onChange={onFilterChange.bind(this, 'estateName')}
                                allowClear
                            >
                                {
                                    _.map(estateList, (estate, i) => (
                                        <Option key={estate} value={estate}>{estate}</Option>
                                    ))
                                }
                            </Select>
                            <Search 
                                placeholder="Search Bar" 
                                style={{ width: 200 }}
                                onSearch={onSearchBarInputChange.bind(this)}
                            />
                        </div>
                        <div className="document-list">
                            <Table 
                                className="document-table"
                                rowKey={'_id'}
                                columns={parentColumns}
                                expandedRowRender={this.getExpandedTable}
                                dataSource={dataset}
                                pagination={false}
                                rowClassName={(record, index) => index === selectedProjectIdx ? 'selected' : ''}
                                onRowClick={onProjectChange}
                            />
                        </div>
                    </div>
                    <DocumentListModal 
                        selectedRowIdx={selectedProjectIdx}
                        selectedDocumentType={selectedDocumentType}
                        visible={showDocumentListModal}
                        onCancel={this.closeDocumentListModal.bind(this)}
                        beforeCreateNewProject={beforeCreateNewProject}
                        listParentColumns={parentColumns}
                        listDataSource={documentList}
                        modalBtnText={modalBtnText}
                        modalRedirect={modalRedirect}
                        filter={filter}
                        searchBarInput={searchBarInput}
                        locationList={locationList}
                        estateList={estateList}
                    />
                </div>
            )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/DocumentList/DocumentList.js